import Raven from '@Raven';
import { createToken } from '../APIs';
import { Country } from '@Configs/Country';
import StoreAuth from '@Stores/User/StoreAuth';
import StoreUser from '@Stores/User/StoreUser';
import { getUserCountryCode } from '@Components/ShoppingHelper';
import { getCustomerStatus } from '@Customer';

export const getHomeBanner = () => {
    const profile = StoreUser.userData || {}
    const { metricsProfileHistory } = profile || {}
    const { aggregate } = metricsProfileHistory || {}
    const { cumulativeMetricsProfile } = aggregate || {}
    const { highestRankShort } = cumulativeMetricsProfile || {}


    const userCountry = Country.getCode3ByCode2(getUserCountryCode())
    const userRank = highestRankShort
    const userStatus = getCustomerStatus()
    const endpoint = `bannerV2/banner/public/${Country.getCode3()}`
    const param = {}

    if (StoreAuth.isAuthorized) {
        param.baId = StoreUser.getID()
        param.token = createToken(StoreUser.getID())
        param.userCountry = userCountry
        param.userRank = userRank
        param.userStatus = userStatus
    }

    return Raven.get(endpoint, param)
}